export function getEnv(key: string): string {
	const value = import.meta.env[key]
	if (typeof value !== "string" || value.trim().length === 0) {
		throw new Error(`Missing environment variable: ${key}`)
	}
	return value.trim()
}

